import { useQuery } from '@tanstack/react-query'
import { catalogApi } from '@/api/resources/catalog'

/** Public catalog reads are rate-limited (60/min) — cache for ≥60s (§5.7). */
const CATALOG_STALE_TIME = 5 * 60 * 1000

export function useCatalogPlans() {
  return useQuery({
    queryKey: ['catalog', 'plans'],
    queryFn: catalogApi.listPlans,
    staleTime: CATALOG_STALE_TIME,
  })
}

export function useCurrencies() {
  return useQuery({
    queryKey: ['catalog', 'currencies'],
    queryFn: catalogApi.listCurrencies,
    staleTime: CATALOG_STALE_TIME,
    // Anonymous-page nicety, not critical path: if this fails (the test
    // service currently 401s it for anonymous visitors — should be
    // permitAll server-side), the pricing UI degrades to base USD prices
    // instead of carding every visitor.
    meta: { silentError: true },
  })
}

export function usePlanPrices(currencyCode: string) {
  return useQuery({
    queryKey: ['catalog', 'plan-prices', currencyCode],
    queryFn: () => catalogApi.listPlanPricesForCurrency(currencyCode),
    staleTime: CATALOG_STALE_TIME,
    meta: { silentError: true }, // fallback to base prices is designed behavior
  })
}
